<template>
  <VaAvatar :size="size" :color="color" :style="{ fontSize: fontSize }">
    {{ userInitials }}
  </VaAvatar>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useAuthStore } from '../stores/auth'

interface Props {
  firstName?: string
  lastName?: string
  size?: number | string
  color?: string
  fontSize?: string
  useStoredData?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  firstName: 'John',
  lastName: 'Doe',
  size: 32,
  color: 'primary',
  fontSize: 'inherit',
  useStoredData: true,
})

const authStore = useAuthStore()

const userInitials = computed(() => {
  // If useStoredData is true and we have member details in store, use those
  if (props.useStoredData && authStore.memberDetails) {
    return authStore.memberInitials
  }

  // Otherwise use the props provided or fallback values
  const first = props.firstName?.charAt(0).toUpperCase() || 'J'
  const last = props.lastName?.charAt(0).toUpperCase() || 'D'
  return `${first}${last}`
})
</script>
